module.exports = __webpack_public_path__ + "static/media/PersonalInformation.2e34c3b5.svg";